import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useContext, useEffect, useState } from 'react';
import { Alert, Badge, Button, Col, Container, Form, Image, InputGroup, Row, Spinner } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import { LinkContainer } from 'react-router-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { LoginInfo } from '../App';
import ApiFetch from './ApiFetch';
import CampaignMessage from './CampaignMessage';
import Category from './Category';
import Dialog from './Dialog';
import FavoriteIcon from './FavoriteIcon';
import FollowButton from './FollowButton';
import Footer from './Footer';
import Header from './Header';
import { useTranslation } from "react-i18next";
import Masonry from "react-masonry-css";
import { FaHatCowboy } from 'react-icons/fa';
import Tile from './common/Tile';
import Thumb from './common/Thumb';
import { isLoggin, updateRenzoku, updateTile } from '../service/LoginService';
import { arrayShuffle, imgPath } from '../service/CommonUtil';
import { Chip, Tab, Tabs } from '@mui/material';
import MuiButton from '@mui/material/Button';
import CommonDialog from './common/CommonDialog';
import AgeSelect from './AgeSelect';
import TaggedImageSlider from './common/TaggedImageSlider';
import Gallery from './common/Gallery';

const Osusume = () => {
    async function getUserSetting(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/userSetting/my")
            .then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getImage(style,generalOrAI,tag,page){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/image/osusume/"+style+"/"+generalOrAI+"/"+tag+"/"+page).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getMessage(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/messages/info").then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    const {t,i18n} = useTranslation()
    // ログイン情報
    const {loginInfo,setLoginInfo} = useContext(LoginInfo)
    // ナビゲーション
    const navigate = useNavigate()

    useEffect(() => {
        if(loginInfo.result){
            // 連続投稿の表示減らす
            setOmitContinuous(loginInfo.renzoku === 1)
            // タイルモード
            setTileMode(loginInfo.tile === 1)
        }
    },[loginInfo])

    // パラメータ
    let param = useParams()
    let style = param.style_of_painting
    let generalOrAI = param.general_or_ai || "all"
    let tag = param.tag || ""
    let genre = {undefined:"("+t("common.general")+")","general":"("+t("common.general")+")","r18":"(R18)","r18g":"(R18G)","all":"("+t("common.all")+")"}

    const [userSetting, setUserSetting] = useState([]);
    const [messageList,setMessageList] = useState([])
    const [imageList,setImageList] = useState([])
    const [imagePage,setImagePage] = useState(1)
    const [oldGeneralOrAI,setOldGeneralOrAI] = useState([])
    const [imageListReset,setImageListReset] = useState(false)
    const [styleOfPainting,setStyleOfPainting] = useState(style || "all")
    const [loading,setLoading] = useState(true)

    // 投稿遅延ロード
    const options = {
        root: null,
        rootMargin: "1000px",
        threshold: 0.05
    }
    const observer = new IntersectionObserver((entries,observer)=>{
        entries.forEach(entry => {
            if(entry.intersectionRatio > 0){
                const imgEl = entry.target;
                //imgEl.src = imgEl.dataset.src;          
                observer.unobserve(entry.target);
                // ロードした部分まで進んだら追加読み込み
                if(imgEl.dataset.no !== undefined && parseInt(imgEl.dataset.no) === (imagePage * 100 - 1) ){
                    setImagePage(imagePage+1)
                }
              }
        })
    }, options);

    useEffect(() => {
        let tempGenre = generalOrAI
        if(generalOrAI === undefined){
            tempGenre = "general"
        }
        getImage(styleOfPainting,tempGenre,tag,imagePage).then(r => {
            if(r.result){
                if(r.data.length > 0){
                    if(oldGeneralOrAI === tempGenre && !imageListReset){
                        setImageList(imageList.concat(arrayShuffle(r.data)))
                    } else {
                        setImageList([].concat(arrayShuffle(r.data)))
                        setImageListReset(false)
                    }
                    /*r.data.forEach((e,i) => {
                        let no = i + (imageList.length === 0 ? 0 : imageList.length)
                        
                        observer.observe(document.getElementById("thumb-"+no))
                        console.log(i)    
                        
                    })*/
                } else {
                    if(imagePage === 1){
                        setImageList([])
                        dialog("","まだ投稿がありません。1枚目を投稿しませんか？")
                    }
                }
            } else {
                setImageList([])
                dialog("確認",r.errors)
            }
            setLoading(false)
        })
        setOldGeneralOrAI(tempGenre)
    },[imagePage,styleOfPainting,generalOrAI,tag])

    useEffect(() => {
        // ユーザ設定
        getUserSetting().then(r => {
            if(r.result){
                setUserSetting(r)
            }
        })
        // メッセージ取得
        getMessage().then(r=>{
            if(r.result){
                setMessageList(r.data)
            }
        })
        // タイトル設定
        document.querySelector("title").textContent = "おすすめ | アワートAI - AI活用プラットフォーム"

    },[])

    const [omitContinuous,setOmitContinuous] = useState(false)
    const [tileMode,setTileMode] = useState(true)
    const [showSetting,setShowSetting] = useState(false)

    // 画像遅延ロード
    useEffect(() => {
        document.querySelectorAll(".lazy").forEach(e => {
            if(e.dataset.lazy !== "1"){
                observer.observe(e)
                e.dataset.lazy = "1"
            }
        })
    },[imageList,tileMode])

    // ダイアログ
    const [show, setShow] = useState(false);
    const [dialogTitle, setDialogTitle] = useState("");
    const [dialogMessage, setDialogMessage] = useState("");
    function dialog(title,message){
        setDialogTitle(title)
        setDialogMessage(message)
        setShow(true)
    }

    const breakpointColumnsObj = {
        default: 9,
        1800: 8,
        1600: 7,
        1400: 6,
        1200: 5,
        992: 4,
        768: 3,
        576: 2,
    }
    return(
    <div className="wrapper">
        <header className="App-header"></header>
        <CommonDialog open={show}
            content={dialogMessage}
            onClick={() => {
                setShow(false)
            }} onClose={() => setShow(false)}
            title={dialogTitle} />
        <Header />
        <Category />        
        <Container style={{backgroundColor:"#FFFFFF"}} className='m-0 p-0'>
            <Container className='p-0' style={{backgroundColor:"inherit"}}>
                <div className='p-0' style={{position:"fixed",zIndex:2,width:"100%",top:"68px",backgroundColor:"inherit",overflow:"auto"}} id="category-bar">
                    <div className='mt-1 mb-1' style={{width:"900px",fontSize:"24px",fontWeight:"bold",backgroundColor:"inherit"}}>
                        <Tabs variant='fullWidth' value="osusume" onChange={(e) => {
                            switch(e.target.tabIndex){
                                case 0:
                                    navigate("/")
                                break
                                case 1:
                                    navigate("/new")
                                break
                                case 2:
                                    navigate("/osusume")
                                break
                                case 3:
                                    navigate("/ranking")
                                break
                                case 4:
                                    navigate("/random")
                                break
                                case 5:
                                    navigate("/newFollow")
                                break
                                case 6:
                                    navigate("/newUser")
                                break
                            }
                            }} centered>
                            <Tab label={"Top"} value="0" tabIndex={0}></Tab>
                            <Tab label={t("home.new")} value="new" tabIndex={1} onClick={() => navigate("/new")}></Tab>
                            <Tab label={t("osusume.title")} value="osusume" tabIndex={2}></Tab>
                            <Tab label={t("category.ranking")} value="ranking" tabIndex={3}></Tab>
                            <Tab label={t("category.discover")} value="random" tabIndex={4}></Tab>
                            <Tab label={t("newFollow.title")} value="newFollow" tabIndex={5}></Tab>
                            <Tab label={t("newUser.title")} value="newUser" tabIndex={6}></Tab>
                            <Icon.GearFill
                            onClick={() => setShowSetting(!showSetting)}
                            style={{fontSize:"32px",marginLeft:"10px",marginRight:"10px",cursor:"pointer"}} />
                        </Tabs>
                    </div>
                </div>
                <div className='p-0' style={{position:"fixed",top:"122px",width:"100%",zIndex:2,backgroundColor:"#FFFFFF",overflow:"auto"}} id="tag-bar">
                    <div className='mt-1 mb-1' style={{width:"1700px",fontSize:"24px",fontWeight:"bold",backgroundColor:"inherit"}}>
                        <div className='d-none'>
                            <Link to={"/osusume/all/"+oldGeneralOrAI+"/"+tag}>
                                <Button onClick={() => {
                                    setImageListReset(true)
                                    setImagePage(1)
                                    setStyleOfPainting("all")
                                }} className='m-1' variant={(styleOfPainting === "all" ? "" : "outline-") + 'secondary'}>{t("common.all")}</Button>
                            </Link>
                            &nbsp;
                            <Link to={"/osusume/illustration/"+oldGeneralOrAI+"/"+tag}>
                                <Button onClick={() => {
                                    setImageListReset(true)
                                    setImagePage(1)
                                    setStyleOfPainting("illustration")
                                }} className='m-1' variant={(styleOfPainting === "illustration" ? "" : "outline-") + 'secondary'}>{t("common.illustration")}</Button>
                            </Link>
                            &nbsp;
                            <Link to={"/osusume/semirealism/"+oldGeneralOrAI+"/"+tag}>
                                <Button onClick={() => {
                                    setImageListReset(true)
                                    setImagePage(1)
                                    setStyleOfPainting("semirealism")
                                }} className='m-1' variant={(styleOfPainting === "semirealism" ? "" : "outline-") + 'secondary'}>{t("common.semirealism")}</Button>
                            </Link>
                            &nbsp;
                            <Link to={"/osusume/photorealistic/"+oldGeneralOrAI+"/"+tag}>
                                <Button  onClick={() => {
                                    setImageListReset(true)
                                    setImagePage(1)
                                    setStyleOfPainting("photorealistic")
                                }} className='m-1' variant={(styleOfPainting === "photorealistic" ? "" : "outline-") + 'secondary'}>{t("common.photorealistic")}</Button>
                            </Link>
                        </div>
                    </div>
                </div>
                <Container style={{position:"fixed",top:"127px",zIndex:2,backgroundColor:"inherit",display:showSetting ? "block" : "none",width:"auto"}} className='p-0'>
                    <AgeSelect to="osusume" loginInfo={loginInfo} generalOrAI={generalOrAI} styleOfPainting={styleOfPainting} onClick={() => {
                        setImagePage(1)
                    }} />
                    <Row style={{width:"600px"}}>
                        <Col xs={8} sm={8} md={7} lg={7} xl={7} xxl={7} style={{}}>
                            <InputGroup style={{}}>
                                <InputGroup.Checkbox style={{cursor:"pointer"}} checked={omitContinuous} onChange={(e) => {
                                    updateRenzoku(e.currentTarget.checked ? "on" : "off").then(r => {
                                        if(r.result){
                                            isLoggin().then(json => {
                                                setLoginInfo(json)
                                            })
                                        }
                                    })
                                    //setOmitContinuous(e.currentTarget.checked)
                                }} />
                                <Form.Control type="text" value={t("common.deduceConsecutiveSubmissions")} readOnly />
                            </InputGroup>
                        </Col>
                        <Col xs={8} sm={8} md={5} lg={5} xl={5} xxl={5} style={{}}>
                            <InputGroup style={{}}>
                                <InputGroup.Checkbox style={{cursor:"pointer"}} checked={tileMode} onChange={(e) => {
                                    updateTile(e.currentTarget.checked ? "on" : "off").then(r => {
                                        if(r.result){
                                            isLoggin().then(json => {
                                                setLoginInfo(json)
                                            })
                                        }
                                    })
                                    //setTileMode(e.currentTarget.checked)
                                    }} />
                                <Form.Control type="text" value={t("common.tileMode")} readOnly />
                            </InputGroup>
                        </Col>
                    </Row>
                </Container>
            </Container>
        </Container>
        <div style={{marginTop:"140px"}}>
            <TaggedImageSlider />
        </div>
        {loading ? <Spinner animation="border" size="lg" style={{marginTop:"80px"}} /> : ""}
        {/*
            <Masonry
                breakpointCols={breakpointColumnsObj}
                className="my-masonry-grid"
                columnClassName="my-masonry-grid_column"
                style={{marginTop:"190px"}}
                >
                {imageList.map((data,i) => {
                    if(imageList[i].favorite === 1 || imageList[i].user_id === loginInfo.userId || data.mute === 1 || (omitContinuous && i > 0 && imageList[i-1].user_id === data.user_id)){
                        return <span data-no={i} className="lazy" key={i}></span>
                    }
                return <Tile data={data} i={i} dialog={dialog} key={i} observer={observer} list={imageList.filter(d => d.mute === 0)} listName={t(("category.new"))} />

                })}
            </Masonry>
        */}
        {tileMode ? (
            <div>
            <Gallery images={imageList.filter((d,i) => i > 2).map(d => {
                d.src = ApiFetch.API_PROTOCOL+'//'+ApiFetch.IMG_HOST + imgPath("image") + '/post/t/'+(d.id)+"_m"+ApiFetch.API_THUMB_EXT
                d.aspect = d.width/d.height
                console.log(d.aspect)
                return d
            }).map((d,i) => {
                if(imageList[i].favorite === 1 || imageList[i].user_id === loginInfo.userId || d.mute === 1 || (omitContinuous && i > 0 && imageList[i-1].user_id === d.user_id)){
                    d.isMute = true
                } else {
                    d.isMute = false
                }
                return d
            })} dialog={dialog} listName={t(("category.new"))} />
            </div>
        ) : (
        <div className='d-flex flex-row justify-content-start flex-wrap w-100'
        style={{marginTop:"190px"}}
        >
            {imageList.map((data,i) => {
                if(imageList[i].favorite === 1 || imageList[i].user_id === loginInfo.userId || data.mute === 1 || (omitContinuous && i > 0 && imageList[i-1].user_id === data.user_id)){
                    return <span data-no={i} className="lazy" key={i}></span>
                }
                return <Thumb data={data} i={i} dialog={dialog} key={i} observer={observer} list={imageList.filter(d => d.mute === 0)} listName={t(("category.new"))} />
            })}
        </div>
        )}
        <Footer />
    </div>
    )
}

export default Osusume;
